export default {
  improvementplans: {
    title: 'แผนการปรับปรุง',
    high: 'สูง',
    middle: 'ปานกลาง',
    low: 'ต่ำ',
    exceed: 'เกิน',
    policy: 'นโยบาย',
    measure: 'การดำเนินการ',
    result: 'ผลลัพธ์',
    currently_supporting: 'อยู่ระหว่างดำเนินการ',
    completion: 'เสร็จสมบูรณ์แล้ว',
    ended: 'ไม่สมบูรณ์',
    risk: 'ความเสี่ยง',
    thema: "@:{'common.esg.category'}",
    improvement_plan: 'แผนการปรับปรุง',
    deadline_for_completion: 'กำหนดเส้นตาย',
    message_count: 'ข้อความ',
    operation: 'การดำเนินการ',
    detail: "@:{'common.scorecard.detail'}",
    indicator: 'ตัวบ่งชี้',
    indicator_point: 'คำแนะนำ',
    buyer_indicator_point: 'ความคิดเห็นเกี่ยวกับการประเมิน',
    status: 'สถานะ',
    supported: 'เสร็จสมบูรณ์แล้ว',
    unsupported: 'ไม่มีการดำเนินการ',
    progress: 'สถานะ',
    advice: {
      text_line_1: '',
      text_line_2: '',
      text_line_3: 'มาเริ่มปรับปรุงประสิทธิภาพ ESG ของคุณจากการประเมินนี้กันดีกว่า',
      text_line_4: 'ตรวจสอบคำแนะนำในการกำหนดเป้าหมายหรือกำหนดเส้นตายจาก "จัดทำแผนการปรับปรุง"',
      text_line_5: 'สามารถตรวจสอบความคืบหน้าได้จากกราฟด้านซ้าย',
      text_line_6: 'โปรด',
      contact: 'ติดต่อเรา',
      please_contact_us: 'หากคุณต้องการขอการประเมินใหม่',
    },
    sub_section_title_1: 'อยู่ระหว่างดำเนินการแผนการปรับปรุง',
    no_data_display: 'ไม่มีข้อมูล',
    sub_section_title_2: 'คำแนะนำที่ไม่สมบูรณ์',
    buyer_sub_section_title_2: 'ความคิดเห็นเกี่ยวกับการประเมินที่ยังไม่เสร็จสมบูรณ์',
    operation_link_text: 'จัดทำแผนการปรับปรุง',
    add_advice: 'เพิ่มคำแนะนำ',
    sub_section_title_3: 'คำแนะนำที่เสร็จสมบูรณ์',
    buyer_sub_section_title_3: 'ความคิดเห็นเกี่ยวกับการประเมินที่เสร็จสมบูรณ์',
    revaluation_request: 'ขอให้ประเมินใหม่',
    cautionary_note: 'คุณต้องการขอการประเมินใหม่ตามแผนการปรับปรุงที่เสร็จสมบูรณ์หรือไม่',
    asterisked_text: 'หากคุณต้องการขอการประเมินใหม่ โปรดดำเนินการจากแบบฟอร์มติดต่อ',
    submit_btn_text: 'ขอให้ประเมินใหม่',
    table_state: 'tableState',
    select_a_file: 'เลือกไฟล์',
    attached_file: 'แนบไฟล์',
    notes: 'หมายเหตุ',
    created_improvement_plan: 'จัดทำแผนการปรับปรุงแล้ว',
    error_file_upload: 'เกิดข้อผิดพลาดในการอัปโหลดไฟล์',
    failed_to_create: 'ไม่สามารถจัดทำแผนการปรับปรุงได้ โปรดลองรีเฟรชหน้า',
    no_data_found: 'ไม่พบข้อมูลสำหรับการปรับปรุง',
    file_upload: {
      filesize_max: 'โปรดเลือกไฟล์ที่มีขนาดน้อยกว่า 10 MB',
      max_files: 'คุณสามารถอัปโหลดไฟล์ได้ถึง 10 ไฟล์',
      confirmation_of_deletion: 'คุณต้องการลบไฟล์นี้หรือไม่',
    },
    create_improvement_plan: 'จัดทำแผนการปรับปรุง',
    no_data_improvement_plan: 'ในขณะนี้ยังไม่มีแผนการปรับปรุงใด ๆ',
  },
  buyer_improvementplans: {
    flag: 'สถานะกำกับ',
    memo: 'บันทึก',
    flag_on: 'ตั้งค่าสถานะ',
    flag_off: 'ลบค่าสถานะออก',
    panel: {
      title: 'ข้อมูล/บันทึกของบริษัท',
      company_memo: 'บันทึกของบริษัท',
      latest_memo: 'บันทึกล่าสุด',
      no_memo: 'ยังไม่มีบันทึกใด ๆ',
      check_list: 'รายการตรวจสอบ',
      memo_list: 'รายการบันทึก',
      // no_assignee: "",
      assignee_select_box: {
        // assignee: "",
        // placeholder: "",
        // create_member: "",
      },
      create_member_modal: {
        // title: "",
        // label: "",
        // place_holder: "",
      },
      delete_member_modal: {
        // title: "",
        // confirm_text: "",
        delete_button_label: "@:{'improvement_plans_detail.chat.delete_confirm.delete_button_label'}",
      },
    },
    back_to_list: 'กลับไปที่รายการ',
    action_cases: 'กรณี',
    no_improvements: 'ไม่มีข้อเสนอแนะเพื่อการปรับปรุงด้านใด ๆ',
    confirm_delete_memo: 'คุณแน่ใจหรือไม่ว่าต้องการลบบันทึกนี้',
    confirm_delete_memo_title: 'ลบบันทึก',
    // display_only_is_marked: "",
    create_memo: 'สร้างบันทึก',
  },
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
    },
  },
}
